// const gradientConfigs = [
//   "linear-gradient(137deg, #004AF6 10.39%, #48B9FF 91.04%)",
//   "linear-gradient(138deg, #513EFC 11.11%, #6A59FF 89.74%)",
//   "linear-gradient(140deg, #11998E 11%, #38EF7D 89.97%)",
//   "linear-gradient(139deg, #F12711 11.76%, #F5AF19 89.15%)",
//   "linear-gradient(140deg, #302B63 10.62%, #5050D8 90.4%)",
//   "linear-gradient(140deg, #0018D0 11.81%, #76B6FF 107.94%)",
//   "linear-gradient(141deg, #45B649 10.84%, #DCE35B 90.06%)",
//   "linear-gradient(136deg, #F37335 10.43%, #FDC830 91.01%)",
//   "linear-gradient(145deg, #2948FF 10.15%, #396AFC 93.1%)",
//   "linear-gradient(142deg, #5B86E5 7.83%, #36D1DC 89.56%)",
//   "linear-gradient(138deg, #0869CB 10.38%, #43CEA2 89.77%)",
//   "linear-gradient(139deg, #D53369 10.29%, #EEA849 89.06%)"
// ];
var gradientConfigs = [
    // "linear-gradient(137deg, #004AF6 10.39%, #48B9FF 91.04%)",
    // "linear-gradient(138deg, #329FFF 11.11%, #968DEB 89.74%)",
    // "linear-gradient(140deg, #8F00EE 11%, #B183FF 89.97%)",
    // "linear-gradient(139deg, #F12711 11.76%, #F5AF19 89.15%)",
    // "linear-gradient(140deg, #3B2DC9 10.62%, #9090FF 90.4%)",
    // "linear-gradient(140deg, #0018D0 11.81%, #76B6FF 107.94%)",
    // "linear-gradient(141deg, #A503B1 10.84%, #FF8EF0 90.06%)",
    // "linear-gradient(136deg, #F37335 10.43%, #FDC830 91.01%)",
    // "linear-gradient(143deg, #4D29FF 10.34%, #6C91FF 89.59%)",
    // "linear-gradient(142deg, #5B86E5 7.83%, #36D1DC 89.56%)",
    // "linear-gradient(138deg, #952AFF 10.38%, #E881FF 89.77%)",
    // "linear-gradient(142deg, #F44 10.77%, #FFD170 90.08%)"
    "#0073FF"
];
// 根据名字生成固定的头像索引
export function getAvatarIndex(name, colorConfigs, wordCount) {
    if (colorConfigs === void 0) { colorConfigs = ["#0073FF"]; }
    if (wordCount === void 0) { wordCount = 2; }
    if (!name)
        return 0;
    var key = name.length >= wordCount ? name.slice(-wordCount) : name;
    var hash = 0;
    for (var i = 0; i < key.length; i++) {
        hash = ((hash << 5) - hash) + key.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash % colorConfigs.length);
}
// 获取 CSS 线性渐变字符串
export function getAvatarGradient(name, colorConfigs) {
    var decorateColorConfigs = colorConfigs.map(function (color) {
        if (color.includes(',')) {
            var color1 = color.split(',')[0];
            var color2 = color.split(',')[1];
            return color1 !== color2 ? "linear-gradient(135deg, " + color1 + " 0%, " + color2 + " 100%)" : color1;
        }
        else {
            return "#0073FF";
        }
    });
    var index = getAvatarIndex(name, decorateColorConfigs);
    return decorateColorConfigs[index];
}
//# sourceMappingURL=gradient_generator.js.map